export * from "./WarningText";
